
import React from 'react';
import { RefreshCw, WifiOff } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';

const OfflineIndicator: React.FC = () => {
    const { isSyncing } = useCart();
    const [isOffline, setIsOffline] = React.useState(!navigator.onLine);

    React.useEffect(() => {
        const handleOnline = () => setIsOffline(false);
        const handleOffline = () => setIsOffline(true);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOffline) {
        return (
            <div className="bg-gray-950 dark:bg-white text-white dark:text-gray-950 px-6 py-3 flex items-center justify-center gap-3 text-[10px] font-black uppercase tracking-[0.2em] shadow-2xl relative z-50 animate-in slide-in-from-top-full duration-500">
                <WifiOff size={14} strokeWidth={3} className="animate-pulse" />
                <span>İnternet Bağlantısı Kesildi. Değişiklikler bağlantı kurulunca eşitlenecek.</span>
            </div>
        );
    }

    if (isSyncing) {
        return (
            <div className="bg-blue-600 dark:bg-blue-500 text-white px-6 py-2 flex items-center justify-center gap-3 text-[10px] font-black uppercase tracking-[0.2em] shadow-xl relative z-40 transition-all">
                <RefreshCw size={12} strokeWidth={3} className="animate-spin" />
                <span>Sepet Bulut ile Eşitleniyor...</span>
            </div>
        );
    }

    return null;
};

export default OfflineIndicator;
